export default __webpack_public_path__ + "static/media/image3.8c355caf.png";